import {
  ConsentProviderInterface,
  ConsentResolvedCallback,
} from "@identity/services";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import { TcfApi } from "../consentProviders/tcf-api";

@singleton()
export class FandomGdprConsentStrategy implements ConsentProviderInterface {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(TcfApi) private readonly tcfApi: TcfApi,
  ) {}

  subscribe(callback: ConsentResolvedCallback): void {
    this.logger.info("__tcfapi installed");
    this.tcfApi.subscribe(callback);
  }
}
